import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/FormControl.scss';

export default function FormControl({
    children,
    className,
    erroneous,
    ...props
}) {
    const classes = classNames(styles.control, {
        [styles.isErroneous]: erroneous,
        // We also render a non-module class to allow javascript hooks
        'is-erroneous': erroneous,
    }, className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

FormControl.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    erroneous: PropTypes.bool,
};
